import { ForeignLanguageState } from './state';
import {
    FOREIGN_LANGUAGE_GENRES_FAILURE,
    FOREIGN_LANGUAGE_GENRES_REQUEST,
    FOREIGN_LANGUAGE_GENRES_SUCCESS,
    FOREIGN_LANGUAGE_PRODUCT_GROUPS_FAILURE,
    FOREIGN_LANGUAGE_PRODUCT_GROUPS_REQUEST,
    FOREIGN_LANGUAGE_PRODUCT_GROUPS_SUCCESS,
    FOREIGN_LANGUAGE_SET_LANGUAGE,
    FOREIGN_LANGUAGE_UNSET_LANGUAGE,
    ForeignLanguageAction,
    LOTE_SET_GENRE,
    LOTE_UNSET_GENRE
} from './types';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';
import { matchPath } from 'react-router';

const initialForeignLanguageState = {
    lote: {},
    loading: false,
    productGroups: {}
} as ForeignLanguageState;

export function foreignLanguageReducer(
    state: ForeignLanguageState = initialForeignLanguageState,
    action: ForeignLanguageAction | LocationChangeAction
): ForeignLanguageState {
    switch (action.type) {
        // Set / unset genre
        case LOTE_SET_GENRE: {
            const genre = action.payload;
            return { ...state, lote: { ...state.lote, selectedGenre: genre } };
        }
        case LOTE_UNSET_GENRE:
            return { ...state, lote: { ...state.lote, selectedGenre: null } };
        // Product groups
        case FOREIGN_LANGUAGE_PRODUCT_GROUPS_REQUEST:
            return { ...state, loading: true };
        case FOREIGN_LANGUAGE_PRODUCT_GROUPS_SUCCESS: {
            const productGroups = action.payload;
            return { ...state, productGroups: productGroups, loading: false };
        }
        case FOREIGN_LANGUAGE_PRODUCT_GROUPS_FAILURE:
            return { ...state, loading: false };
        // Genres
        case FOREIGN_LANGUAGE_GENRES_REQUEST:
            return { ...state, lote: { ...state.lote, loading: true } };
        case FOREIGN_LANGUAGE_GENRES_SUCCESS: {
            const genres = action.payload;
            return { ...state, lote: { ...state.lote, genres: genres, loading: false } };
        }
        case FOREIGN_LANGUAGE_GENRES_FAILURE:
            return { ...state, lote: { ...state.lote, loading: false } };
        // Set / Unset language
        case FOREIGN_LANGUAGE_SET_LANGUAGE: {
            const language = action.payload;
            return { ...state, selectedLanguage: language };
        }
        case FOREIGN_LANGUAGE_UNSET_LANGUAGE:
            return { ...state, selectedLanguage: null };
        case LOCATION_CHANGE:
            return reduceLocationChange(state, action);
        default:
            return state;
    }
}

function reduceLocationChange(
    state: ForeignLanguageState,
    {
        payload: {
            location: { pathname }
        }
    }: LocationChangeAction
): ForeignLanguageState {
    if (
        matchPath(pathname, [
            '/language/lote/all',
            '/language/lote/ebooks',
            '/language/lote/eaudiobooks',
            '/language/languagelearning/all',
            '/language/languagelearning/ebooks',
            '/language/languagelearning/eaudiobooks'
        ])
    ) {
        return state;
    }

    const match = matchPath<{ languageId: string }>(pathname, [
        '/language/lote/:languageId',
        '/language/languagelearning/:languageId'
    ]);
    if (match) {
        return {
            ...state,
            selectedLanguage: decodeURIComponent(match.params['languageId'])
        };
    }

    return state;
}
